export default __webpack_public_path__ + "static/media/cymsa2_c.cde1a708.jpg";